module.exports = __webpack_public_path__ + "assets/images/presente_05d6f8d83d528f1d7be6e0abfd21ebca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yellow/cubo/presente.png
// module id = 200
// module chunks = 0